<template>
  <v-checkbox
    @click.native.stop="onClick"
    v-model="model"
    :input-value="value"
    :label="label"
    :id="id"
    v-on="$listeners"
    :true-value="trueValue"
    :false-value="falseValue"
    :disabled="disabled"
    :error="error"
    :indeterminate="indeterminate"
    :rules="[(v) => required === false || v === trueValue || $i18n.VALIDATION.NEW_TRANSLATION_REQUIRED]"
    ref="fpCheckbox"
    hide-details="auto"
    :color="color"
    class="fp-checkbox"
    :class="{
      'label-fade': labelFade || disabled,
      'borderless': borderless,
      'short': short,
    }"
    :data-test="resolvedDataTest"
  >
     <template #label v-if="description || $scopedSlots['label']">
      <slot name="label" :label="label" :description="description">
        <span class="text--primary">{{label}}</span>
        <br>
        <span>{{description}}</span>
      </slot>
      </template>
  </v-checkbox>
</template>

<script>
import {resolveDataTest} from './useDataTest';

export default {
  name: 'FpCheckbox',
  props: {
    dataTest: {
      type: String,
      default: undefined,
    },
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
    required: {
      default: false,
    },
    value: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    labelFade: {
      type: Boolean,
      default: false,
    },
    short: {
      type: Boolean,
      default: false,
    },
    defaultStyles: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary-text',
    },
    description: {
      type: String,
    },
    label: {
      type: String,
    },
    id: {
      type: String,
      default: undefined,
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    resolvedDataTest() {
      return resolveDataTest(this.dataTest, this.id);
    },
    model: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.emitValue(newValue);
      },
    },
  },
  methods: {
    emitValue(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    },
    onClick(value) {
      this.$emit('click', value);
    },
  },
};
</script>

<style scoped lang="scss">
  .fp-checkbox {
    &.label-fade ::v-deep label {
      opacity: .6;
    }
    &.label-fade.v-input--is-label-active ::v-deep label{
      opacity: 1!important;
    }
  }
  .fp-checkbox.short:not(.borderless) {
    display: inline-flex!important;
    ::v-deep .v-input__control {
      display: inherit!important
    }
    .v-input__slot {
      display: inherit!important;
      width: fit-content;
      label {
        display: inherit!important;
        margin-right: 4px;
      }
    }
  }
  .fp-checkbox:not(.borderless):not(:last-of-type) {
    margin-bottom: 8px
  }

  .v-input--checkbox {
    margin-top: 0;
    padding-top: 0;
    ::v-deep label {
      width: 100%;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      overflow: hidden;
      flex-wrap: wrap!important;
      height: 100%;
      display: block;
      padding: 0 8px;
      span:first-child {
        width: 100%;
        font-size: 16px;
        line-height: 24px;
        font-weight: 500;
      }
      span:last-child {
        font-size: 14px;
        line-height: 20px;
        font-style: italic;
        font-weight: 300;
      }
    }
    &:not(.borderless) ::v-deep .v-input__slot {
      border: 1px solid var(--token-core-border);
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      margin-bottom: 0;
      .v-input--selection-controls__input {
        margin: 6px
      }
      .v-input--selection-controls__ripple {
        z-index: 123;
      }
      &:hover {
        .v-icon {
          color: var(--token-primary-base);
        }
        border: 1px solid var(--token-primary-base);
      }
    }
    &.v-input--is-label-active:not(.borderless) {
       ::v-deep .v-input__slot {
        border: solid 1px var(--token-core-border);
       }
    }
    &
    &.borderless {
      min-height: 44px;
      ::v-deep label {
        min-height: 44px;
      }
    }
  }
</style>
